// extracted by mini-css-extract-plugin
export default {"field":"LabelCreateStep_field__zlAh2","fieldLabel":"LabelCreateStep_fieldLabel__cABR3","controls":"LabelCreateStep_controls__jhx4k"};